const URL_1 = "https://ipinfo.io/json";
const shipTo = document.getElementById("ship_to_city");
const getCityData = async(URL_1) => {
  if (!localStorage.getItem("cityData")) {
        const cityData = await fetch(URL_1).then(data => {return data.json()}).then(async(res) => {
        let city = res.city;
        return city;
  });
      await localStorage.setItem("cityData", cityData);
      return shipTo.innerHTML = ` ${localStorage.getItem("cityData")}`;
  } else {
    return shipTo.innerHTML = ` ${localStorage.getItem("cityData")}`;
  }
}

getCityData(URL_1);











